"use client";

import { ReactNode } from "react";

// Prominent display of the SMS header (sender id) for the send confirmation.
export function SenderHeader({ sender }: { sender: string }) {
  return (
    <div className="mb-4 rounded-lg border border-accent-200 bg-accent-50 px-4 py-3 dark:border-accent-500/30 dark:bg-accent-500/15">
      <p className="text-[11px] font-semibold uppercase tracking-wider text-accent-700 dark:text-accent-300">SMS Header · Sender ID</p>
      <p className="mt-0.5 text-lg font-bold text-gray-900">{sender || "—"}</p>
    </div>
  );
}

export function ConfirmRow({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="flex items-start justify-between gap-4 border-t border-gray-50 py-2 text-sm first:border-t-0">
      <dt className="shrink-0 text-gray-500">{label}</dt>
      <dd className="max-w-[65%] break-words text-right font-medium text-gray-900">{children}</dd>
    </div>
  );
}

export function MessagePreview({ message }: { message: string }) {
  return (
    <div className="mt-3">
      <p className="mb-1 text-xs font-medium text-gray-500">Message</p>
      <div className="max-h-40 overflow-y-auto whitespace-pre-wrap rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-800">
        {message || <span className="text-gray-400">(empty)</span>}
      </div>
    </div>
  );
}
